<template>
  <div class="paa-toolbar">
    <select
      v-if="showPerPage"
      class="paa-ctl"
      aria-label="Rows per page"
      :value="perPage"
      @change="$emit('per-page', $event.target.value)"
    >
      <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }} per page</option>
    </select>
    <input
      class="paa-ctl paa-ctl--grow"
      type="text"
      :placeholder="placeholder"
      :value="search"
      @input="$emit('update:search', $event.target.value)"
      @keydown.enter.prevent="$emit('search')"
    />
    <span class="paa-ctl paa-daterange">
      <input type="date" aria-label="From" :value="from" @input="$emit('update:from', $event.target.value)" />
      <span class="paa-muted">~</span>
      <input type="date" aria-label="To" :value="to" @input="$emit('update:to', $event.target.value)" />
    </span>
    <button type="button" class="paa-btn paa-btn--primary" :disabled="busy" @click="$emit('search')">Search</button>
    <slot />
  </div>
</template>

<script>
import { PA_ADMIN_PER_PAGE_OPTIONS } from './paAdminConstants'

/** Design toolbar: per page, search, date range (from ~ to), orange Search, then the export slot. */
export default {
  name: 'PopAuthorityAdminToolbar',
  props: {
    perPage: { type: Number, default: 15 },
    search: { type: String, default: '' },
    placeholder: { type: String, default: 'Search by email or user ID' },
    from: { type: String, default: '' },
    to: { type: String, default: '' },
    showPerPage: { type: Boolean, default: true },
    busy: { type: Boolean, default: false },
  },
  data () {
    return { perPageOptions: PA_ADMIN_PER_PAGE_OPTIONS }
  },
}
</script>
